module.exports = __webpack_public_path__ + "img/g-coin.0635d479.svg";